<div class="subnet-container">
  <div class="subnet-added-list" *ngIf="parent === 'subnets'">
    <div class="subnet" *ngFor="let subnet of subnetList">
      <div class="subnet-name">
        <div class="subnet-name-label">{{subnet.name}}</div>
        <span class="subnet-name-description">{{subnet.description}}</span>
      </div>
      <div class="subnet-range">{{subnet.subnet}}</div>
      <div class="subnet-action">
        <div class="subnet-action-btn" (click)="removeSubnet(subnet)">
          <mat-icon class="carret">highlight_off</mat-icon>
        </div>
      </div>
    </div>
  </div>
  <div class="subnet-added-list" *ngIf="parent === 'tags'">
    <div class="subnet" *ngFor="let tag of tagList">
      <div class="tag-name">{{tag}}</div>
      <div [ngClass]="parent === 'subnets'?'subnet-action':'tag-action'">
        <div class="subnet-action-btn" (click)="removeSubnet(tag)">
          <mat-icon class="carret">highlight_off</mat-icon>
        </div>
      </div>
    </div>
  </div>
  <div class="subnet-input-container">
    <form
      [ngClass]="parent === 'subnets'?'subnetForm':'tagForm'"
      [formGroup]="subnetForm"
      novalidate
    >
      <div class="subnet-input-group">
        <div matInput class="tag-name" *ngIf="parent === 'tags'">
          <input
            autocomplete="off"
            placeholder="Tag name"
            id="tagName"
            formControlName="name"
            maxlength="30"
          />
        </div>
        <div class="name" *ngIf="parent === 'subnets'">
          <input
            autocomplete="off"
            matInput
            placeholder="Subnet name"
            id="subnetName"
            formControlName="name"
            maxlength="30"
          />
          <div class="error" *ngIf="f.name.dirty || f.name.touched">
            <mat-error *ngIf="subnetForm.hasError('maxlength', 'name')"
              >Name is too long.</mat-error
            >
          </div>
        </div>

        <div class="range" *ngIf="parent === 'subnets'">
          <input
            autocomplete="off"
            matInput
            placeholder="Subnet range 192.0.5.12/8"
            id="subnet"
            formControlName="subnet"
            (ngModelChange)="subnetUpdated()"
          />
          <div class="error" *ngIf="f.subnet.dirty || f.subnet.touched">
            <mat-error *ngIf="subnetForm.hasError('matchPattern', 'subnet')"
              >invalid subnet</mat-error
            >
            <mat-error>{{errorMsg}}</mat-error>
            <mat-error class="subnet-check" *ngIf="checkingSubnet"
              ><mat-spinner [diameter]="15" [strokeWidth]="2"></mat-spinner
              ><span>checking subnet availability...</span></mat-error
            >
          </div>
        </div>
        <!--Refer ATW-3745 - Commented the code since we should hide this for release version 2.0 -->
        <!-- <div class="subnet-description" *ngIf="parent === 'subnets'">
                    <input autocomplete="off" matInput placeholder="Description" formControlName="description" maxlength="60" />
                </div> -->
      </div>
    </form>
    <div class="subnet-btn-container">
      <div *ngIf="parent === 'tags'" class="tag-add-btn" (click)="makeOutput()">
        <mat-icon>add_new</mat-icon>
      </div>
      <button
        *ngIf="parent === 'subnets'"
        [disabled]="subnetForm.invalid"
        class="btn btn-blue subnet-add-btn"
        (click)="checkSubnetsWithOtherSites()"
      >
        <mat-icon>add_new</mat-icon>
      </button>
    </div>
  </div>
</div>
